import React, { useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { closeModal, openModal } from 'store/admin/pendingContent';
import { modalsSelector } from 'store/admin/pendingContent/selectors';

import Confirm from './index';

const useModal = (id, params) => {
  const dispatch = useDispatch();
  const modals = useSelector(modalsSelector);

  return useMemo(() => {
    const data = modals[id];
    const onOpen = (data) => dispatch(openModal({ id, data }));
    const onUpdate = (update) => onOpen({ ...data, ...update });
    const element = Boolean(data) && <Confirm {...params(data, onUpdate)} onClose={() => dispatch(closeModal(id))} />;

    return [element, onOpen, data];
  }, [id, params, dispatch, modals]);
};

export default useModal;
